import React, { useEffect } from "react";
import { IItemData } from "./common.typing";
import PageTitle from "./PageTitle";
import CommonList from "./CommonList";
import AlphabetContactList from "./AlphabetContactList";
import type { IGroupedContacts } from "./AlphabetContactList";

export interface GroupMemberProps {
    prePage: string;
    onChangeCurPage: (page: string) => void;
    currentList: IItemData[];
    setCurrentList: (list: IItemData[]) => void;
    getGroupMemberList?: (id: number | string) => void;
    groupMemberList: IItemData[];
    groupMemberGrouped?: IGroupedContacts;
    currentGroupInfo: { id: number | string; name: string };
    disabledids?: string[];
    requiredList?: IItemData[];
    isHideGroupMemberPageTitle?: boolean;
    isShowGroupMemberRole?: boolean;
    showCheckAll?: boolean;
    multiple?: boolean;
}

const GroupMember: React.FC<GroupMemberProps> = ({
    prePage,
    onChangeCurPage,
    currentList,
    setCurrentList,
    groupMemberList,
    groupMemberGrouped,
    getGroupMemberList,
    currentGroupInfo,
    disabledids,
    requiredList,
    isHideGroupMemberPageTitle = false,
    isShowGroupMemberRole,
    showCheckAll,
    multiple,
}) => {
    useEffect(() => {
        getGroupMemberList?.(currentGroupInfo.id);
    }, []);

    const onBack = () => onChangeCurPage(prePage);
    const hasGroupedData = groupMemberGrouped && Object.keys(groupMemberGrouped).length > 0;

    // A-Z 分组展示
    if (hasGroupedData && groupMemberGrouped) {
        return (
            <div className="myGroup alphabetView">
                {!isHideGroupMemberPageTitle && <PageTitle title={currentGroupInfo.name} onBack={onBack} />}
                <AlphabetContactList
                    groupedData={groupMemberGrouped}
                    disabledids={disabledids}
                    currentList={currentList}
                    setCurrentList={setCurrentList}
                    requiredList={requiredList}
                    multiple={multiple}
                    showCheckAll={showCheckAll}
                />
            </div>
        );
    }

    // 普通列表展示
    return (
        <div className={`myGroup ${isHideGroupMemberPageTitle ? "hideTitle" : ""}`}>
            {!isHideGroupMemberPageTitle && <PageTitle title={currentGroupInfo.name} onBack={onBack} />}
            <CommonList
                type="member"
                isShowOrg={true}
                showCheckAll={showCheckAll}
                list={groupMemberList}
                currentList={currentList}
                setCurrentList={setCurrentList}
                disabledids={disabledids}
                requiredList={requiredList}
                isShowGroupMemberRole={isShowGroupMemberRole}
                multiple={multiple}
            />
        </div>
    );
};

export default GroupMember;
